var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.59 1.48826H19.41C19.74 1.48826 20 1.15753 20 0.737769C20 0.330724 19.74 0 19.41 0H0.59C0.26 0 0 0.330724 0 0.737769C0 1.15753 0.26 1.48826 0.59 1.48826ZM0.59 7.25049H19.41C19.74 7.25049 20 6.91977 20 6.5C20 6.08024 19.74 5.74951 19.41 5.74951H0.59C0.26 5.74951 0 6.08024 0 6.5C0 6.91977 0.26 7.25049 0.59 7.25049ZM0.59 13H19.41C19.74 13 20 12.6693 20 12.2495C20 11.8297 19.74 11.499 19.41 11.499H0.59C0.26 11.499 0 11.8297 0 12.2495C0 12.6693 0.26 13 0.59 13Z",
    fill: "#282829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.8f50ba3cac8b900e9e2c04b7c8fad5a9.svg";
export { ForwardRef as ReactComponent };